import Papa from "papaparse";
import { useMemo } from "react";

import type { Artifact } from "@/types/eryndal";
import { ArtifactFrame } from "./common";
import { downloadBlob, safeFilename } from "./download";

export function CsvArtifact({ artifact }: { artifact: Artifact }) {
  const parsed = useMemo(() => {
    return Papa.parse<string[]>(artifact.payload, {
      skipEmptyLines: true,
    });
  }, [artifact.payload]);

  const rows = parsed.data;
  const header = rows[0] ?? [];
  const body = rows.slice(1);
  const filename = `${safeFilename(artifact.title, "data")}.csv`;

  return (
    <ArtifactFrame
      title={artifact.title}
      kindLabel="csv"
      rightSlot={
        <button
          type="button"
          onClick={() => downloadBlob(artifact.payload, filename, "text/csv")}
          className="font-mono text-[0.7rem] tracking-normal normal-case text-oxblood-500 hover:text-oxblood-600"
        >
          download .csv ↓
        </button>
      }
    >
      <table className="min-w-full border-collapse font-serif text-sm">
        <thead>
          <tr className="border-b border-ruleline">
            {header.map((cell, i) => (
              <th
                key={i}
                className="border-r border-ruleline px-3 py-2 text-left text-smallcaps text-warmgray-500 last:border-r-0"
              >
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row, rIdx) => (
            <tr key={rIdx} className="border-b border-ruleline last:border-b-0">
              {row.map((cell, cIdx) => (
                <td
                  key={cIdx}
                  className="border-r border-ruleline px-3 py-2 text-espresso-700 last:border-r-0"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </ArtifactFrame>
  );
}
